import { toast } from "react-hot-toast";

export const exportToCSV = (dataList, columns, fileName) => {
    if (!dataList || dataList.length === 0) {
        toast.error("No data available to export");
        return;
    }

    // 1. Create Headers using the keys from the columns
    const header = columns.map(col => col.name);

    // 2. Map data to rows
    const rows = dataList.map(item => 
        columns.map(col => {
            // Evaluates the selector function (if provided) or accesses property
            let cellValue = col.selector ? col.selector(item) : item[col.name];
            // Format to string and escape quotes
            return `"${String(cellValue || '').replace(/"/g, '""')}"`; 
        })
    );

    // 3. Combine into CSV format
    const csvContent = [header, ...rows]
        .map(row => row.join(","))
        .join("\n");

    const csvDataUri = `data:text/csv;charset=utf-8,${encodeURIComponent(csvContent)}`;

    // 4. Download
    const downloadLink = document.createElement("a");
    downloadLink.href = csvDataUri;
    downloadLink.download = fileName;
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};
